import { ApiFabricator } from '@app/tests/utils/fabricators/ApiFabricator'

import type { ApiTimeZone } from '@app/packages/api/v2/types/entities'

export class ApiTimeZoneFabricator extends ApiFabricator<ApiTimeZone> {
  protected getBase = (): ApiTimeZone => ({
    type: 'timezones',
    id: ApiFabricator.getId('timezones'),
    attributes: {
      formatted_offset: '+03:00',
      name: 'Москва',
      utc_offset: 360,
    },
  })

  static newYork(): ApiTimeZone {
    return new this().setId('America/NewYork').setAttr('name', 'New York').setAttr('formatted_offset', '-05:00').setAttr('utc_offset', -300).get()
  }

  static london(): ApiTimeZone {
    return new this().setId('Europe/London').setAttr('name', 'London').setAttr('formatted_offset', '+00:00').setAttr('utc_offset', 0).get()
  }

  static milan(): ApiTimeZone {
    return new this().setId('Europe/Rome').setAttr('name', 'Milan').setAttr('formatted_offset', '+01:00').setAttr('utc_offset', 60).get()
  }

  static moscow(): ApiTimeZone {
    return new this().setId('Europe/Moscow').setAttr('name', 'Москва').setAttr('formatted_offset', '+03:00').setAttr('utc_offset', 360).get()
  }

  static istanbul(): ApiTimeZone {
    return new this().setId('Europe/Istanbul').setAttr('name', 'Istanbul').setAttr('formatted_offset', '+03:00').setAttr('utc_offset', 180).get()
  }

  static tokyo(): ApiTimeZone {
    return new this().setId('Asia/Tokyo').setAttr('name', 'Tokyo').setAttr('formatted_offset', '+09:00').setAttr('utc_offset', 540).get()
  }

  static list(): ApiTimeZone[] {
    return [this.newYork(), this.london(), this.milan(), this.moscow(), this.istanbul(), this.tokyo()]
  }
}
